import React from 'react'

function HomeLandingPage() {
  return (
    <div>Home_landing_page</div>
  )
}

export default HomeLandingPage